module.exports = __webpack_public_path__ + "static/media/iconQTI.711bcf50.svg";